export default __webpack_public_path__ + "static/automobile-roundabout-2aa6cd7587ff0c05cb4306adb3367d11.gif";